<template>
  <el-form
    ref="messagesForm"
    class="messagesForm"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <el-row>
      <el-col
        :xs="16"
        :sm="20"
      >
        <el-input
          v-model="form.new_message"
          type="text"
          name="new_message"
          :placeholder="$t('messages.form.newMessagePlaceholder')"
        />
      </el-col>
      <el-col
        :xs="8"
        :sm="4"
        class="messagesForm__send-container"
      >
        <el-button
          class="messagesForm__send"
          type="primary"
          :disabled="!form.new_message"
          :loading="loading"
          native-type="submit"
        >{{ $t('messages.form.sendButton') }}</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>

export default {
  name: "MessagesForm",
  data: () => ({
    form: {
      new_message: null
    },
    loading: false
  }),
  computed: {
    rules() {
      return {
        new_message: { required: true, type: 'string', message: this.$t('forms.validation.invalidNewMessage') }
      }
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const validation = await this.$refs["messagesForm"].validate()

        if (validation) {
          await this.$store.dispatch("records/sendMessage", {
            recordId: this.$route.params.id,
            message: {
              content: this.form.new_message
            }
          })
          this.form.new_message = null
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: ".messagesForm";

#{$c} {
  &__send-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>